import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    nombre: Yup.string().required('El nombre es obligatorio'),
    apellido1: Yup.string().required('El primer apellido es obligatorio'),
    email: Yup.string().required('El email es obligatorio').email('El formato del email no es correcto.'),
    numero_documento: Yup.string().required('El número de documento es obligatorio'),
    id_tipo_documento: Yup.string().required('El tipo de documento es obligatorio'),
    id_tipo_relacion: Yup.string().required('El tipo de relación es obligatorio'),
})